import { FC } from 'react';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { BookingStep } from '../../types/booking.types';

interface NavigationControlsProps {
  currentStep: BookingStep;
  onBack: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  isSubmitting?: boolean;
  nextLabel?: string;
}

export const NavigationControls: FC<NavigationControlsProps> = ({
  currentStep,
  onBack,
  onNext,
  isNextDisabled = false,
  isSubmitting = false,
  nextLabel,
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === 5;

  const getNextButtonLabel = (): string => {
    if (nextLabel) return nextLabel;
    if (isLastStep) return 'Confirm Booking';
    return 'Continue';
  };

  const getNextButtonIcon = () => {
    if (isLastStep) return <Check className="h-4 w-4" aria-hidden="true" />;
    return <ArrowRight className="h-4 w-4" aria-hidden="true" />;
  };

  return (
    <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-between">
      {/* Back Button */}
      <div>
        {!isFirstStep && (
          <Button
            type="button"
            variant="outline"
            onClick={onBack}
            disabled={isSubmitting}
            leftIcon={<ArrowLeft className="h-4 w-4" aria-hidden="true" />}
          >
            Back
          </Button>
        )}
      </div>

      {/* Next/Submit Button */}
      <Button
        type="button"
        variant="primary"
        onClick={onNext}
        disabled={isNextDisabled || isSubmitting}
        isLoading={isSubmitting}
        loadingText={isLastStep ? 'Confirming...' : 'Processing...'}
        rightIcon={!isSubmitting ? getNextButtonIcon() : undefined}
        className="sm:min-w-[160px]"
      >
        {getNextButtonLabel()}
      </Button>
    </div>
  );
};
